import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { ICustomerContact } from "../../../../Orchestrator/Types/Index";
import { UpdateCustomerContactForm } from "../../../../Orchestrator/Types/Types/Passenger/PassengerType";

export class UpdateContactFormDataAction extends BaseAction<{updatedCustomer: ICustomerContact | null}, UpdateCustomerContactForm> {

    sanitizeName = (
        value: string | Date | null,
        field: string
    ): string | Date | null => {
        if (
            (field === "firstName" || field === "lastName") &&
            typeof value === "string"
        ) {
            return value.replace(/[^\p{L}\p{M}\s-]/gu, "");
        }
        return value;
    };

    override async run(): Promise<{updatedCustomer: ICustomerContact | null}> {
        let updatedCustomer: ICustomerContact | null = null;
        try {
            const { field, value, customerContact } = this.params!;
            updateRecoilState("customerContactStateAtom", {
                ...customerContact,
                [field]: this.sanitizeName(value, field as string),
            });
            const updatedContact = {
                ...customerContact,
                [field]: this.sanitizeName(value, field as string),
            };
            updatedCustomer = updatedContact
        } catch (error) {
            console.error("Error in UpdateContactFormDataAction:", error);
        } finally {
            return { updatedCustomer }
        }
    }
}

// Create a singleton instance
export const updateContactFormDataAction = new UpdateContactFormDataAction(); 